const stabSearchboxMessage = function(key) {
  return window.__INITIAL_STATE__.intl.messages[key] || null;
};

export default stabSearchboxMessage;



// WEBPACK FOOTER //
// ./src/universal/helpers/stabSearchboxMessage.js